import { createSelector } from '@ngrx/store';
import { AssetTimeline } from '@zero/shared/util-models';
import { instrumentDetailFeature } from './instrument-detail.reducer';

export const selectAssetTimelineItems = createSelector(
  instrumentDetailFeature.selectAssetTimeline,
  (assetTimeline: AssetTimeline) => assetTimeline?.items?.content,
);

export const selectAssetTimelineHasNext = createSelector(
  instrumentDetailFeature.selectAssetTimeline,
  (assetTimeline: AssetTimeline) => !assetTimeline?.items?.last,
);
